import React from "react";
import Form from 'react-bootstrap/Form';
import { Badge, Table } from 'react-bootstrap';
import { LinkContainer } from "react-router-bootstrap";

export default function CompletedProgramsTable(props) {
    return (
        <div>
            <Table>
                <thead>
                    <tr>
                        <th>Programs</th>
                        <th></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    { props.submittedPrograms &&
                        props.submittedPrograms.map((program,key) =>
                            <tr key={key}>
                                <td>{program.name}</td>
                                <td>
                                    {program.status === 'in-progress' &&
                                        <Badge bg="primary" text="light">In-Progress</Badge>
                                    }
                                    {program.status === 'completed' &&
                                        <Badge bg="success" text="light">Completed</Badge>
                                    }
                                </td>
                                <td className="mx-auto pull-right">
                                    {program.programId in props.programAssessments
                                    ?<LinkContainer
                                        to={'/assessment/view/' + props.programAssessments[program.programId]?.assessmentId}
                                        >
                                        <a href={'/assessment/view/' + props.programAssessments[program.programId]?.assessmentId}
                                            className="btn btn-outline-primary pull-right"
                                            role="button">
                                                View
                                            </a>
                                    </LinkContainer>
                                    :<></>
                                    }
                                </td>
                            </tr>
                        )
                    }
                </tbody>
            </Table>
        </div>
    )
}